import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { disableButton } from '../../slices/countDownSlice';

const CountDown = ({ closeDate, todayDate, size }) => {
  const dispatch = useDispatch();
  const [timeLeft, setTimeLeft] = useState({});

  const calculateTimeLeft = (num) => {
    const serverTime = new Date(todayDate);
    const closeTime = new Date(closeDate);
    // const closeTime = new Date('2022-03-16 11:57:00');
    // const serverTime = new Date('2022-03-16 11:56:55');

    const diff = closeTime - serverTime - num;

    // When countDown ends
    if (diff < 1000 && diff > 0) {
      dispatch(disableButton());
    }

    let timeLeftValue = {};

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / 1000 / 60) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    timeLeftValue = {
      days: days < 0 ? 0 : days,
      hours: hours < 0 ? 0 : hours,
      minutes: minutes < 0 ? 0 : minutes,
      seconds: seconds < 0 ? 0 : seconds,
    };
    setTimeLeft(timeLeftValue);
    return timeLeftValue;
  };

  const [counter, setCounter] = useState(0);
  const intervalRef = useRef();
  intervalRef.current = counter;
  useEffect(() => {
    const timer = setInterval(() => {
      setCounter(intervalRef.current + 1000);
      calculateTimeLeft(intervalRef.current + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const sizeCounter = () => {
    let widthCounter;
    if (size === 'middle' && timeLeft.days > 0) {
      widthCounter = 'd-flex bd-primary br-1 w-70 count-down-middle bg-white text-tangaroa';
    } else if (size === 'middle' && timeLeft.days <= 0) {
      widthCounter = 'd-flex bd-primary br-1 w-71 count-down-middle bg-white text-tangaroa';
    } else {
      widthCounter = 'd-flex bd-primary br-1 count-down bg-white text-tangaroa';
    }
    return widthCounter;
  };

  return (
    <>
      <Row>
        <Col className="d-none d-lg-block">
          <div className={sizeCounter()}>
            {timeLeft.days > 0 ? (
              <div className="font-weight-bold numbers ml-3">
                {timeLeft.days}
                <span className="font-weight-light text ml-1">días</span>
              </div>
            ) : ''}
            <div className="font-weight-bold numbers ml-3">
              {timeLeft.hours}
              <span className="font-weight-light text ml-1">hrs</span>
            </div>
            <div className="font-weight-bold numbers ml-3">
              {timeLeft.minutes}
              <span className="font-weight-light text ml-1">mins</span>
            </div>
            {timeLeft.days > 0 ? '' : (
              <div className="font-weight-bold numbers ml-3">
                {timeLeft.seconds}
                <span className="font-weight-light text ml-1">segs</span>
              </div>
            ) }
          </div>
        </Col>

        <Col className="d-block d-lg-none">
          <div className="d-flex bd-primary br-1 bg-white">
            {timeLeft.days > 0 ? (
              <div className="font-weight-bold ft-30 hours ml-3">
                {timeLeft.days}
                <span className="font-weight-light ft-16 ml-1">días</span>
              </div>
            ) : ''}
            <div className="font-weight-bold ft-30 hours ml-3">
              {timeLeft.hours}
              <span className="font-weight-light ft-16 ml-1">hrs</span>
            </div>
            <div className="font-weight-bold ft-30 minutes ml-3">
              {timeLeft.minutes}
              <span className="font-weight-light ft-16 ml-1">mins</span>
            </div>
            {timeLeft.days > 0 ? '' : (
              <div className="font-weight-bold ft-30 seconds ml-3">
                {timeLeft.seconds}
                <span className="font-weight-light ft-16 ml-1">segs</span>
              </div>
            ) }
          </div>
        </Col>
      </Row>
    </>
  );
};

CountDown.propTypes = {
  closeDate: PropTypes.string.isRequired,
  todayDate: PropTypes.string.isRequired,
  size: PropTypes.string,
}.isRequired;

export default CountDown;
